import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Loader from "components/atoms/loader/index.jsx";
import Button from "components/atoms/button/index.jsx";
import Header from "components/organisms/header/index.jsx";
import Footer from "components/organisms/footer/index.jsx";
import Carousel from "components/organisms/carousel/index.jsx";
import Filters from "components/molecules/filters/index.jsx";
import VehicleCard from "components/molecules/vehicleCard/index.jsx";
import RequestCard from "components/molecules/requestCard/index.jsx";
import SearchFilter from "components/atoms/searchFilter/index.jsx";
import Seals from "components/atoms/seals";
import findPromotionForVehicle from "helpers/findPromotionForVehicle";
import { fetchStock } from "actions/stock";
import StoryBlock from "components/organisms/storyBlock";

import "./styles.scss";

class App extends React.Component {
  componentDidMount() {
    this.props.fetch();
  }

  render() {
    const { promotionCode, stories, banners } = this.props;

    return (
      <div>
        <Helmet>
          <title>Vehículos usados - Territorio Yacopini</title>
          <meta
            name="description"
            content="Autos usados seleccionados de Territorio Yacopini"
          />
        </Helmet>
        <Header />
        <Carousel banners={banners} />
        <StoryBlock stories={stories} />

        <div className="container">
          <div className="sidebar">
            <Filters />
          </div>
          <div className="mainContent">
            <div className="search-bar">
              <SearchFilter />
              <Seals />
            </div>
            <div className="carlist">
              {this.props.loading && <Loader />}
              {this.props.vehicles.map((vehicle, i) => {
                return (
                  <VehicleCard
                    vehicle={vehicle}
                    key={i}
                    availablePromotion={findPromotionForVehicle(
                      promotionCode,
                      vehicle
                    )}
                  />
                );
              })}

              <RequestCard>
                <h3>¿No encontrás lo que buscás?</h3>
                <p className="m">
                  Decinos cual es tu vehículo ideal y lo buscamos por vos.
                </p>
                <br />
                <br />
                <Link to="/pedi-tu-usado">
                  <Button buttonText="Pedí tu usado" style="white" />
                </Link>
              </RequestCard>
            </div>
          </div>
        </div>
        <Footer seals />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    vehicles: state.stock.items,
    loading: state.stock.isFetching,
    promotionCode: state.stock.promotionCode,
    stories: state.stock.stories,
    banners: state.stock.parameters.banners,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetch: () => {
      dispatch(fetchStock());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
